
<ng-container>
    <div class="">
        <!-- START HEADER-->
    
        <!-- CLOSE HEADER-->
          
        <ng-container *ngIf="renderURL" >
            <mux-player  stream-type="on-demand"
            default-hidden-captions
            attr.poster="{{renderURL}}"
            attr.playback-id='{{idOrSlug}}'>
          </mux-player>
          </ng-container>

    </div>
</ng-container>

